export const COMMON_ADD_LOADING = 'COMMON_ADD_LOADING';
export const COMMON_REMOVE_LOADING = 'COMMON_REMOVE_LOADING';
export const COMMON_SET_SPIN = 'COMMON_SET_SPIN';
export const COMMON_SET_SHOW_MODAL_LOGIN = 'COMMON_SET_SHOW_MODAL_LOGIN';
export const COMMON_SET_TITLE_MODAL_LOGIN = 'COMMON_SET_TITLE_MODAL_LOGIN';
export const COMMON_SET_IS_CLICK_MENU_BOOKED =
    'COMMON_SET_IS_CLICK_MENU_BOOKED';
export const COMMON_SET_IS_INAPP = 'COMMON_SET_IS_INAPP';
export const COMMON_SET_LANGUAGE = 'COMMON_SET_LANGUAGE';
